import { MeshStandardMaterial } from 'three';

/**
 * Applies realistic material properties to reduce plastic/shiny appearance
 * @param object - The 3D object to process
 */
export function applyRealisticMaterials(object: any) {
    object.traverse((child: any) => {
        if (child.isMesh && child.material) {
            if (child.material instanceof MeshStandardMaterial) {
                // Reduce metalness to make it less shiny
                child.material.metalness = Math.min(child.material.metalness, 0.1);
                
                // Increase roughness to reduce plastic look
                child.material.roughness = Math.max(child.material.roughness, 0.7);
                
                // Reduce reflectivity
                child.material.reflectivity = Math.min(child.material.reflectivity || 0.5, 0.3);
                
                // Enable proper tone mapping
                child.material.toneMapped = true;
                
                // Update the material
                child.material.needsUpdate = true;
            } else if (child.material.isMeshStandardMaterial) {
                // Handle cases where material might not be properly typed
                child.material.metalness = Math.min(child.material.metalness || 0, 0.1);
                child.material.roughness = Math.max(child.material.roughness || 0.5, 0.7);
                child.material.needsUpdate = true;
            }
        }
    });
}

/**
 * Applies natural material properties for organic/natural objects
 * @param object - The 3D object to process
 */
export function applyNaturalMaterials(object: any) {
    object.traverse((child: any) => {
        if (child.isMesh && child.material) {
            if (child.material instanceof MeshStandardMaterial) {
                // Make it completely non-metallic
                child.material.metalness = 0;
                
                // High roughness for natural look
                child.material.roughness = 0.8;
                
                // Low reflectivity for natural materials
                child.material.reflectivity = 0.1;
                
                child.material.toneMapped = true;
                child.material.needsUpdate = true;
            }
        }
    });
}

/**
 * Applies metal material properties for metallic objects
 * @param object - The 3D object to process
 */
export function applyMetalMaterials(object: any) {
    object.traverse((child: any) => {
        if (child.isMesh && child.material) {
            if (child.material instanceof MeshStandardMaterial) {
                // Higher metalness for metal objects
                child.material.metalness = 0.7;
                
                // Lower roughness for metals but not mirror-like
                child.material.roughness = 0.3;
                
                child.material.toneMapped = true;
                child.material.needsUpdate = true;
            }
        }
    });
}
